import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, CircularProgress, Alert } from '@mui/material';
import QrCode2Icon from '@mui/icons-material/QrCode2';

const API_PATH = '/createqr';

function QR() {
  const [cccd, setCccd] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e?.preventDefault();
    const value = (cccd || '').trim();
    if (!value) {
      setError('Vui lòng nhập số CCCD');
      return;
    }

    setLoading(true);
    setError('');
    setImageUrl('');
    setLink('');

    const baseUrl = process.env.REACT_APP_DOMAIN || '';
    if (!baseUrl) {
      setError('Thiếu cấu hình REACT_APP_DOMAIN');
      setLoading(false);
      return;
    }

    const url = `${baseUrl.replace(/\/+$/, '')}${API_PATH}?cccd=${encodeURIComponent(value)}`;

    try {
      const res = await fetch(url);
      const data = await res.json();

      if (!res.ok) {
        setError(data?.message || data?.error || `HTTP ${res.status}`);
        setLoading(false);
        return;
      }

      if (data.ok && data.imageUrl) {
        setImageUrl(data.imageUrl);
        setLink(data.link || '');
      } else {
        setError(data?.message || 'Không nhận được ảnh QR');
      }
    } catch (err) {
      setError(err.message || 'Lỗi kết nối');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 560 }}>
      <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <QrCode2Icon /> QR theo CCCD
      </Typography>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'flex-start' }}>
          <TextField
            label="Số CCCD"
            placeholder="VD: 066304001703"
            value={cccd}
            onChange={(e) => setCccd(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
            size="small"
            required
            sx={{ minWidth: 260 }}
          />
          <Button
            type="submit"
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <QrCode2Icon />}
          >
            {loading ? 'Đang tạo…' : 'Tạo QR'}
          </Button>
        </Box>
      </Paper>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}

      {imageUrl && (
        <Paper sx={{ p: 2 }}>
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
            Ảnh QR
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}>
            <img
              src={imageUrl}
              alt="QR CCCD"
              style={{ maxWidth: '100%', height: 'auto', border: '1px solid #e0e0e0', borderRadius: 8 }}
            />
            {link && (
              <Typography variant="body2" color="text.secondary">
                Link: <a href={link} target="_blank" rel="noopener noreferrer">{link}</a>
              </Typography>
            )}
          </Box>
        </Paper>
      )}
    </Box>
  );
}

export default QR;
